import { Accordion } from '@liveauctioneers/hammer-ui-core/accordion';
import { Checkbox } from '@liveauctioneers/hammer-ui-core/checkbox';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { useLocation } from 'react-router-dom';

import { useNavigateSearchPageWithParams } from '@/pages/SearchPageSimplified/hooks/useNavigateSearchPageWithParams';
import { CurrentOpenMenu } from '@/pages/SearchPageSimplified/types';
import { getRoundedNumberText } from '@/pages/SearchPageSimplified/utils/getRoundedNumberText';
import { useAppSelector } from '@/redux/hooks';
import { getMergedOptionFacet } from '@/redux/modules/searchFacetAggregates.selectors';
import { FacetOption } from '@/types/FacetOption';
import FacetTypes from '@/types/search/enums/facetTypes';
import { FilterAction } from '@/types/SearchFacet';
import { modifyParamsRemovePage, modifyParamsWhenChecked, parseQueryParams } from '@/utils/queryParams';

export const BuyingFormatFilter = () => {
    const { formatMessage } = useIntl();
    const { search } = useLocation();
    const queryParams = parseQueryParams(search);
    const navigateWithParams = useNavigateSearchPageWithParams();
    const buyingFormatFacet = useAppSelector((state) => getMergedOptionFacet(state, false, FacetTypes.SALE_TYPE_ID));
    const { options = [] } = buyingFormatFacet;

    const onBuyingFormatOptionClick = (option: FacetOption) => {
        const newCheckStatus = !option.selected;

        let newParams = modifyParamsWhenChecked(queryParams, FacetTypes.SALE_TYPE_ID, option.id, newCheckStatus);

        newParams = modifyParamsRemovePage(newParams);

        navigateWithParams({
            currentOpenMenu: CurrentOpenMenu.AllFilters,
            filterAction: newCheckStatus ? FilterAction.BuyingFormatChanged : FilterAction.BuyingFormatRemoved,
            params: newParams,
            preventScrollReset: true,
        });
    };

    return (
        <Accordion
            className="w-full"
            density="compact"
            emphasis="subtle"
            headline={formatMessage({ id: 'search_facet_title_sale_type' })}
            open
        >
            <div className="flex flex-col gap-xs">
                {options.map((option) => (
                    <Checkbox.Option
                        checked={option.selected}
                        disabled={option.count === 0}
                        key={option.id}
                        onChange={() => onBuyingFormatOptionClick(option)}
                    >
                        {option.name} ({getRoundedNumberText({ totalFound: option.count })})
                    </Checkbox.Option>
                ))}
            </div>
        </Accordion>
    );
};
